module.exports = __webpack_public_path__ + "img/qingcloud.dfe1b083.svg";